const pages = [
  'CompareMaps',
  'CompareSprites',
  'CompareSchemas',
  'MeasurePerformance'
];

export default pages;
